import { OrganizationPaymentType } from 'data/__generated__';

export const STRIPE_SEPA_DEBIT: string = 'sepa_debit';
export const STRIPE_CARD: string = 'card';

export const TOTEM_ORGANIZATION_ID: string = '8j3PvACaXMpdJbeT5';

// Modes d'encaissement où TOTEM ne prélève RIEN : `Odoo` encaisse lui-même (virement / SDD gérés dans
// Odoo), `NoPayment` n'encaisse pas du tout. Dans les deux cas le client n'a aucun moyen de paiement
// Stripe à enregistrer — ni carte, ni IBAN, et rien à saisir avant de valider une commande.
//
// Miroir de `STRIPE_COLLECTED_PAYMENT_TYPES` (api/src/constants/organization.constants.ts) : on teste
// l'APPARTENANCE à une liste, jamais l'égalité à un seul mode. Le `paymentType === 'Odoo'` qui vivait
// ici en cinq exemplaires réclamait une carte aux organisations « Sans encaissement » et leur bloquait
// la validation du panier.
const PAYMENT_TYPES_WITHOUT_TOTEM_COLLECTION: string[] = [
    OrganizationPaymentType.Odoo,
    OrganizationPaymentType.NoPayment,
];

// `paymentType` absent = organisation encore en vol : on répond `true`, comme avant, pour ne jamais
// masquer la section paiement sur une donnée qu'on n'a pas encore reçue.
export const requiresStripePaymentMethod = (paymentType?: string | null): boolean =>
    !PAYMENT_TYPES_WITHOUT_TOTEM_COLLECTION.includes(paymentType ?? '');
